import layout from './SearchBox.html?raw';
import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import SearchBoxViewModelType from '@/Components/SearchView/SearchBox/SearchBoxViewModel';
import NavigationService from '@/Management/NavigationService';
import ResourceManager from '@/Management/ResourceManager';
import DatePickerViewModel from '@/ViewModels/Controls/DatePickerViewModel';

export default class SearchBox extends Control {

    private jQueryControl: JQuery;
    private initialized: boolean;
    private _isolatedViewFactoryCount;

    public constructor(private viewModel: SearchBoxViewModelType, private element?: JQuery) {
        super(viewModel, element);


        this.defineSubscription(this.viewModel.timezoneFrom.rawValue, () => this.validateDatePicker());
        this.defineSubscription(this.viewModel.timezoneUntil.rawValue, () => this.validateDatePicker());

        this.initialized = false;

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.applyTemplateAsync(layout, this.jQueryControl, 5, () => {
            this.initialized = true;
            this._isolatedViewFactoryCount = NavigationService.getInstance().getModalViewFactories();
        });

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'searchbox',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            }),

            hotkey: {
                shortcut: 'alt+.',
                handler: () => {
                    let mainSearchField = $('.searchbox-container > .mainSearchField').last();

                    if (this._isolatedViewFactoryCount == NavigationService.getInstance().getModalViewFactories()) {
                        mainSearchField.find('input').focus();
                    }

                    return false;
                },
                isGlobal: true

            },

            locator: this.viewModel.locator
        });

        if (this.viewModel.autoComplete != null) {
            this.viewModel.autoComplete.onClick = () => {
                this.viewModel.isPopupOpen(false);
            };
        }

        if (this.viewModel.link != null) {
            this.viewModel.link.onClick = () => {
                this.getOptionsPopup().css({
                    top: this.jQueryControl.position().top + this.jQueryControl.outerHeight() + 1,
                    left: this.jQueryControl.position().left,
                    width: this.jQueryControl.width(),
                    minHeight: 100,
                    maxHeight: window.innerHeight - (this.jQueryControl.offset().top + this.jQueryControl.outerHeight() + 10),
                    overflowY: 'visible'
                }).toggle();
            };

            // Optionen verstecken, wenn außerhalb des Controls geklickt wird
            this.addEventHandler('blur', this.jQueryControl, (evt) => {
                if (!this.initialized) // Während der Initialisierung entstehen einige Events, die uns nicht interessieren
                {
                    return;
                }

                // Hier beobachtet man ein interessantes Verhalten der DropdownLists innerhalb des Optionen-divs;
                // Verlieren diese den Fokus, so ist zunächst kein relatedTarget gesetzt und daher werden die Optionen ausgeblendet --
                // allerdings wird unmittelbar danach ein simuliertes Event abgefeuert; blendet man daraufhin die Optionen einfach wieder ein,
                // so erhält man das richtige Verhalten. 
                // Wir erkennen die simulierten Events Browser-übergreifend anhand der Anwesenheit des Event-Properties "view"
                let popup = this.getOptionsPopup();
                if (evt.view != null) {
                    if (evt.relatedTarget == null || !$.contains(this.jQueryControl[0], evt.relatedTarget)) {
                        // Dies hat nichts mit obigem Verhalten zu tun, beobachtet bei Klicks vom Eingabefeld auf außerhalb des Controls
                        this.viewModel.isPopupOpen(false);
                    }
                    else if (popup.is(evt.relatedTarget) || $.contains(popup[0], evt.relatedTarget)) {
                        // Oben beschriebenes Verhalten; die Optionen sollen sichtbar bleiben (genau: wieder sichtbar werden), wenn
                        // eine DropdownList innerhalb der Optionen den Fokus verliert und dabei ein anderes Element in den Optionen den Fokus wiedererhält
                        this.viewModel.isPopupOpen(true);
                        $(evt.relatedTarget).focus();
                    }
                    return;
                }

                // Klick außerhalb der Optionen, Optionen ausblenden
                // Beim Enabled-Status-Wechsel des Zurücksetzen-Buttons werden zwei blur-Events geworfen, in dem Fall sorgt toggle für das gewünschte Verhalten
                if ($.contains(this.jQueryControl[0], evt.target) && (evt.relatedTarget == null || !$.contains(this.jQueryControl[0], evt.relatedTarget))) {
                    if ($.contains(popup[0], evt.target)) {
                        this.viewModel.isPopupOpen(true);
                        popup.focus();
                    }
                    else {
                        this.viewModel.isPopupOpen(false);
                    }
                }
            }, '.searchbox-container');
        }

        if (this.viewModel.onSubmit != null) {
            this.addEventHandler('submit', this.jQueryControl.find('input'), () => {
                this.viewModel.isPopupOpen(false);
                this.viewModel.onSubmit();
            });
        }
    }

    private validateDatePicker(): void {
        // Um sicher zu stellen, dass der Format Fehler gegenüber dem Zeitraumfehler Priorität hat müssen immer beide DatePicker validiert werden
        this.viewModel.validateDatePicker(this.viewModel.timezoneFrom);
        this.viewModel.validateDatePicker(this.viewModel.timezoneUntil);
    }

    private getOptionsPopup(): JQuery<HTMLElement> {
        return this.jQueryControl.find('.options');
    }
}

ComponentManager.setControl('SearchBox', SearchBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');